/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { VodLaunchDetails, VodPurchaseStatus } from 'client-code/vod-browse';

import { VodBrowseServiceRepositoryImpl } from '../impls';
import { IVodBrowseService, IVodBrowseServiceRepository } from '../interfaces';
import { TServicesParams, TVodBrowseData } from '../types';

export class VodBrowseService implements IVodBrowseService {
    private readonly TAG: string = 'VodBrowseService';

    private mVodBrowseServiceRepository: IVodBrowseServiceRepository;

    public constructor(params: TServicesParams) {
        this.mVodBrowseServiceRepository = new VodBrowseServiceRepositoryImpl(params);
    }

    /**
     * @inheritdoc
     */
    public async getVodBrowseData(
        vodBrowseItemsParams: {
            parentVodItemId?: string;
            includeAdult?: boolean;
            offset?: number;
            limit?: number;
        } = {},
    ): Promise<TVodBrowseData> {
        const vodBrowseData =
            await this.mVodBrowseServiceRepository.fetchVodBrowseData(vodBrowseItemsParams);
        return vodBrowseData;
    }

    /**
     * @inheritdoc
     */
    public async getVodLaunchInfo(vodJumpChannelNumber: string): Promise<VodLaunchDetails> {
        const vodLaunchInfo =
            await this.mVodBrowseServiceRepository.fetchVodLaunchInfo(vodJumpChannelNumber);
        return vodLaunchInfo;
    }

    /**
     * @inheritdoc
     */
    public async purchaseVodItem(vodPurchaseParams: {
        applicationFeatureArea: string;
        partnerOfferId: string;
        price?: string;
    }): Promise<VodPurchaseStatus> {
        const vodPurchaseStatus =
            await this.mVodBrowseServiceRepository.vodPurchasePost(vodPurchaseParams);
        return vodPurchaseStatus;
    }
}
